import { newPassword, newPasswordConfirm } from 'config/inputs';

const resetPasswordConfig = {
  inputsById: [
    'newPwd', 'newPwdConfirm'
  ],

  inputsByHash: {
    newPwd: newPassword,
    newPwdConfirm: newPasswordConfirm,
  }
}

export default resetPasswordConfig;